export const COUNTRIES = [
  "United States",
  "United Kingdom",
  "United Arab Emirates",
  "Singapore",
  "Canada",
  "Australia",
  "Germany",
  "Other",
];

export const INTERESTS = [
  "AI Investment",
  "Personalised Advice",
  "Real Estate",
  "Record Keeping",
  "Tax-Aware Planning",
  "Repatriation Support",
];
